import { createReducer, on } from '@ngrx/store';
import { FilterReservationState } from '../states/filters-reservations.state';
import { setFiltersReservations } from '../actions/filters-reservations.actions';

export const initialState: FilterReservationState = {
  filterReservation: undefined,
};

export const ReservationsReducers = createReducer(
  initialState,
  on(setFiltersReservations, (state, { filtersReservations }) => {
    return { ...state, filterReservation: filtersReservations };
  })
);
